/*
 * @Author: your name
 * @Date: 2021-06-23 12:40:32
 * @LastEditTime: 2021-06-25 17:16:59
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \standard-business\client\src\store\modules\app.js
 */
import Cookies from 'js-cookie';

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus')
      ? !!+Cookies.get('sidebarStatus')
      : true,
    withoutAnimation: false,
  },
  sellerBookingType: 0, // 0 直邮商城 1 自提商城
  isFullPage: false,
  device: 'desktop',
  isShowGuide: Cookies.get('isShowGuide')
    ? Cookies.get('isShowGuide') === 'true'
      ? true
      : false
    : false,
};

const mutations = {
  TOGGLE_BUSINESS_TYPE: state => {
    window.localStorage.setItem(
      'sellerBookingType',
      state.sellerBookingType === 0 ? 1 : 0
    );
    state.sellerBookingType = state.sellerBookingType === 0 ? 1 : 0;
  },
  SET_BUSINESS_TYPE: (state, type) => {
    state.sellerBookingType = type;
  },
  SET_APP_FULLPAGE: (state, v) => {
    state.isFullPage = v;
  },
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  OPEN_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 1);
    state.sidebar.opened = true;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language;
    Cookies.set('language', language);
  },
  SET_GUIDE_SHOW: (state, isShowGuide) => {
    state.isShowGuide = isShowGuide;
    Cookies.set('isShowGuide', isShowGuide);
  },
};

const actions = {
  setBusinessType({ commit }, { type }) {
    commit('SET_BUSINESS_TYPE', type);
  },
  toggleBusinessType({ commit }) {
    commit('TOGGLE_BUSINESS_TYPE');
  },
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  openSideBar({ commit }, { withoutAnimation }) {
    commit('OPEN_SIDEBAR', withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device);
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language);
  },
  setGuideShow({ commit }, isShowGuide) {
    commit('SET_GUIDE_SHOW', isShowGuide);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
